import { render, staticRenderFns } from "./SignStyleEditor.vue?vue&type=template&id=d48281f4&scoped=true&"
import script from "./SignStyleEditor.vue?vue&type=script&lang=ts&"
export * from "./SignStyleEditor.vue?vue&type=script&lang=ts&"
import style0 from "./SignStyleEditor.vue?vue&type=style&index=0&id=d48281f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48281f4",
  null
  
)

export default component.exports